import { render, staticRenderFns } from "./popup-reward-record.vue?vue&type=template&id=2f14b404&scoped=true&"
import script from "./popup-reward-record.vue?vue&type=script&lang=js&"
export * from "./popup-reward-record.vue?vue&type=script&lang=js&"
import style0 from "./popup-reward-record.vue?vue&type=style&index=0&id=2f14b404&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f14b404",
  null
  
)

export default component.exports